import React, { Component, Fragment } from 'react';
import { isEmpty, size } from 'lodash';

import { 
    Menu, 
    MenuItem,
    Button,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Box,
    Tabs,
    Tab,
    IconButton,  
} from '@mui/material';
import { SearchBarV2 } from '../../common/SearchBar';
import UserSingle from '../Users/UserSingle';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import TitleWithEndAction from '../../common/TitleWithEndAction';
import TableWithFilters from '../../common/TableWithFilters';
import { AddRounded, MoreVertRounded } from '@mui/icons-material';
import LoanDemandSingle from './Single/LoanDemandSingle';

const DEMAND_TITLE = {
    "DEMAND_WAITING": "Traiter la demande",
    // "DEMAND_UPDATED": "Valider",
    "DEMAND_VALIDATE": "Preparation",
    "DEMAND_READY": "Remise",
    // "DEMAND_PICKED_UP": "Recap",
}

class EquipementUsers extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openAccessForm: false,
        anchorEl: null, 
        openMenu: "", 
        user: {},
        updatePassword: false,
        updateUser: false,
        updateUserFromSingle: false,
        singleUser: false, 
        tab: 0,

        searchUser: "",
        user_is_active: "",
        index: 0,

        openDemand: false,
        singleDemand: {}
    }

    handleChange = (e) => {
        this.setState({ searchUser: e.target.value });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        console.log("handle rows", event.target.value);
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if(!this.props.STATE.users.fetched && !this.props.STATE.users.fetching){
            this.props.fetchUsers()
        }
        // if(!this.props.STATE.equipements.fetched && !this.props.STATE.equipements.fetching){
        //     this.props.fetchEquipements()
        // }
        // if(!this.props.STATE.vehicules.fetched && !this.props.STATE.vehicules.fetching){
        //     this.props.fetchVehicules()
        // }
        // if(isEmpty(this.props.LOCALISATIONS.PARENT)){
        //     this.props.fetchParentLocalisations()
        // }
        // if(isEmpty(this.props.LOCALISATIONS.CHILD)){
        //     this.props.fetchChildLocalisations()
        // }
        // if(isEmpty(this.props.IMMO_TAGS)){
        //     this.props.fetchImmoTags()
        // }

        if(!this.props.STATE.employees.fetched && !this.props.STATE.employees.fetching){
            this.props.fetchEmployees()
        }
        if(!this.props.STATE.loanDemands.fetched && !this.props.STATE.loanDemands.fetching){
            this.props.fetchLoanDemands()
        }
        
    }



    handleSingleUser = (user) => {
		this.setState({
			user,
            singleUser: true,
            openMenu: "",
            anchorEl: null
		})
	}
      
    getFilteredList = () => {
        const { USERS } = this.props;
        const { searchUser } = this.state;
        let list = Object.values(USERS)
        // users
        // console.log('====================================');
        // console.log({searchUser});
        // console.log('====================================');
        if(!isEmpty(searchUser)){
            list = list.filter( user => (
                user.username.toLowerCase().includes(searchUser.toLowerCase()) ||
                user.email.toLowerCase().includes(searchUser.toLowerCase()) ||
                user.lastname.toLowerCase().includes(searchUser.toLowerCase())
            ))
        }
        return list
    }

    displayList = () => {
        const { USERS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(USERS)){
            let all = this.getFilteredList()            
            rows = size(all)
            // console.log('====================================');
            // console.log({all, rows});
            // console.log('====================================');
            tab.push(this.getUserList(all))
        }
        return {tab, rows}
    }


    getUserList = (list) => {
        // if (!isEmpty(list)){
            return list.map(user =>  (
                <TableRow key={user.user_id} onClick={() => this.handleSingleUser(user)} className="clickable" hover>
                    <TableCell>{user.lastname && user.lastname.toUpperCase()}</TableCell>
                    <TableCell><b>{user.username}</b></TableCell>
                    <TableCell>{user.email}</TableCell>
                </TableRow>
            ))
        // }
    }

    render() {
        const { singleUser, user, index, openDemand, singleDemand } = this.state;
        const { LOAN_DEMANDS, USERS } = this.props;
        const { tab, rows } = this.displayList();
        return (
            <Box>
                {singleUser && user && 
                    <UserSingle
                        open={true}
                        handleCloseAll={() => this.setState({ singleUser: false, user: {} }) }
                        user={user}
                        // handleOpenUpdate={ () => this.handleOpenUpdateFromSingle(user) } 
                        {...this.props}
                        IMMO
                    />
                }
                {openDemand && singleDemand && 
                    <LoanDemandSingle
                        open={true}
                        handleCloseAll={() => this.setState({ openDemand: false, singleDemand: {} }) }
                        DEMAND={LOAN_DEMANDS[singleDemand.demand_loan_id]}
                        // handleOpenUpdate={ () => this.handleOpenUpdateFromSingle(user) } 
                        {...this.props}
                    />
                }

                
                <TitleWithEndAction
                    title={"Employés et Demandes"}
                    // action={() => this.props.openFormDownload("/extract/equipements")}
                    // actionTitle="Télécharger" 
                    // disabled={this.props.downloading}
                >
                    {/* <Fab 
                        color={"secondary"} 
                        onClick={() => this.setState({ openActions: true })} 
                        title="Nouvel Équipement"
                        size="small"
                    >
                        <AddRounded />
                    </Fab> */}
                </TitleWithEndAction>
                
                <SwipeableTabs
                    returnIndex={(index) => this.setState({ index })}
                    labels={["Employés", "Demandes"]}
                    // labels={["Immos", "Matériels", "Véhicules", "Planning"]}
                >
                    {index == 0 ?
                        <Box p={1}>
                    
                            <SearchBarV2
                                handleChange={this.handleChange} 
                                label="Rechercher un Utilisateur"
                                searchValue={this.state.searchUser}
                            />
        
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nom</TableCell>
                                        <TableCell>Prénom</TableCell>
                                        <TableCell>Email</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tab}
                                </TableBody>
                            </Table>
                        </Box>
                        :
                        <Box></Box>
                    }
                    {index == 1 ?
                        <Box p={1}>
                            <TableWithFilters
                                internalId="demand_loan_id"
                                rows={Object.values(LOAN_DEMANDS)}
                                // filterList={this.handleFilters}
                                columns={[
                                    {
                                        field: 'lastname',
                                        headerName: 'Nom', 
                                        width: 150,
                                        sortable: true,
                                        valueGetter: (params) =>
                                        `${USERS[params.row.demand_user].lastname}`,
                                    },
                                    {
                                        field: 'username',
                                        headerName: 'Prénom', 
                                        width: 150,
                                        sortable: true,
                                        valueGetter: (params) =>
                                        `${USERS[params.row.demand_user].username}`,
                                    },
                                    {
                                        field: 'demand_status',
                                        headerName: 'Statut', 
                                        width: 210,
                                        sortable: true,
                                        valueGetter: (params) =>
                                        `${params.row.demand_status}`,
                                    },
                                    {
                                        field: 'details',
                                        headerName: 'Details',
                                        sortable: false,
                                        width: 300,
                                        renderCell: (params) => ( 
                                            DEMAND_TITLE[params.row.demand_status] ?
                                                <Button 
                                                    aria-controls={`option-menu${params.row.demand_loan_id}`} 
                                                    aria-haspopup="true"
                                                    onClick={() => this.setState({ openDemand: true, singleDemand: params.row}) }
                                                    variant="contained"
                                                    color={(params.row.demand_status == "DEMAND_WAITING" ? "primary" : "secondary")}
                                                    style={{width: "100%"}}
                                                >
                                                    {DEMAND_TITLE[params.row.demand_status]}
                                                </Button>
                                            :
                                                <IconButton 
                                                    aria-controls={`option-menu${params.row.demand_loan_id}`} 
                                                    aria-haspopup="true"
                                                    onClick={() => this.setState({ openDemand: true, singleDemand: params.row}) }
                                                >
                                                    <AddRounded />
                                                </IconButton>
                                        )
                                    },
                                    {
                                        field: 'demand_creation_date',
                                        headerName: "Date de Demande", 
                                        // valueGetter: (params) => `${new Date(params.row.demand_creation_date).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.demand_creation_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.demand_creation_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 150
                                    },
                                    {
                                        field: 'demand_start_date',
                                        headerName: "Date Début", 
                                        // valueGetter: (params) => `${new Date(params.row.demand_start_date).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.demand_start_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.demand_start_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 150
                                    },
                                    {
                                        field: 'demand_end_date',
                                        headerName: "Date Fin", 
                                        // valueGetter: (params) => `${new Date(params.row.equipement_date_acquisition)}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.demand_end_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.demand_end_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 150
                                    },
                                ]}
                            />
                        </Box>
                        :
                        <Box></Box>
                    }
                </SwipeableTabs>
            </Box>
        );
    }
}

export default EquipementUsers;